<template lang="html">
    <v-layout row>
      <!-- <v-flex xs4>
        <v-subheader>{{field.title}}</v-subheader>
      </v-flex> -->
      <v-flex xs12>
        <v-select v-if="field.type == 'select' && field.enum" v-model="curr_value"
            v-bind:items="field.enum"
            :label="field.placeholder?field.placeholder:''"
            item-value="_id"
            item-text ="name"
        ></v-select>
        <v-text-field v-else 
            clearable
            :error-messages="err_msg"
            v-model= "curr_value"
            :rules = "rules?rules:[]"
            :label="field.placeholder?field.placeholder:''"
        ></v-text-field>
      </v-flex>
    </v-layout>

</template>

<script>
/*listReport, groupOperation, deleteItem, addItem, importExcle,updateItem, downloadFile, httpCommand, autoComplete*/
// import {refSelectoption,autoComplete} from '@/api/report'
export default {
    name: 'myInput',
    components: {},
    model: {
        prop: 'value',
        event: 'change',

    },
    props: {
        value       :[String, Number,Object,Boolean,Array],
        field       :Object,
        rules       : Array,
        err_msg     :{type: Array,default:()=>[]}
        // size        :String,
        // placeholder :String,
        // width       :{type :String,default:'100%'},
        // quickadd    :{type :Boolean,default:true},
        // ref_cache   :{type : Object,default:function(){return {}}},        
    },
    data(){
        return {
            // cache     : [],
            // ref_lable : 'name',
            // ref_value : '_id' ,
            // ref_key   : '_id',
            /*******************/
            curr_value:   Array.isArray(this.value)? this.value: (typeof(this.value)=='object' && this.value!= null)?this.value._id:this.value 
        }
    },
    watch: {
        value(val){
            this.curr_value =val;
            console.log("binding change:",val)
        },
        curr_value(value){
            console.log("curr_value changed!",value)
            // let val= {value,fd:this.field.name};
            this.$emit('change',value);
            if(this.field.type == 'checkboxs'){
                this.$emit('checkboxs',value);
            }
        }
    },
    methods: {
        /*
        fetch_suggestions(obj, lookfor, cb){
            // debugger
            if(!lookfor){
                cb([])
            }else{
                Api.table_field_autocomplete(obj, lookfor).then(res => {
                    this.autoTpl = res.data.template;
                    cb(res.data.data);
                })
            }
        },
        handleSelect(item){
            console.log("SELECT:",item);
            this.$emit('suggestion',item);
        },
        quickAddRef(ref, title){
            if(this.quickadd)
                this.$emit('quick_add_ref_table',ref,title);
        }
        */
        // ,
        // checkbox_notify(new_val){
        //    console.log("curry value:",this.curr_value,new_val)
        //    this.$emit('checkboxs',this.curr_value,new_val); 
        // }
    },
    created(){}
}
</script>

<style lang="css">
</style>






// WEBPACK FOOTER //
// src/views/front_sale/components/form_item.vue